let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gEi5K")).then(() => parcelRequire('3nvKi'));